module.exports = __webpack_public_path__ + "odinstatic/v13.0.1/media/pod.cbb0a7b1.svg";